
import { SearchFilters } from '../../../apps/search/schemas'
import { Component, Prop, Vue } from 'vue-property-decorator'

@Component
export default class SearchSummaryBarDetailsBounds extends Vue {
  @Prop()
    searchFilters: SearchFilters

  @Prop({ default: true })
    useLink: boolean

  getModifiedSearchFilters(filters: Partial<SearchFilters>) {
    const filtersToUpdate = { ...filters }
    if (this.searchFilters.previousPath) {
      filtersToUpdate.hierarchyPath = this.searchFilters.previousPath
      filtersToUpdate.previousPath = null
    }
    if (this.searchFilters.previousPoint) {
      const { area, placename } = this.searchFilters.previousPoint
      filtersToUpdate.area = area
      filtersToUpdate.placename = placename
      filtersToUpdate.previousPoint = undefined
    }
    return { ...this.searchFilters, ...filtersToUpdate }
  }
}
